export const MATRIX_OPEN_ENDED_MIN_STATEMENTS = 1;
export const MATRIX_OPEN_ENDED_MAX_STATEMENTS = 20;
export const MATRIX_OPEN_ENDED_MIN_SCALEPOINTS = 1;
export const MATRIX_OPEN_ENDED_MAX_SCALEPOINTS = 20;

export const MATRIX_CONSTANT_SUM_MIN_SCALEPOINTS = 1;
export const MATRIX_CONSTANT_SUM_MIN_STATEMENTS = 1;

export const MATRIX_OPEN_ENDED_STATEMENT_STEP = 1;
export const MATRIX_OPEN_ENDED_SCALEPOINT_STEP = 1;

export const MATRIX_OPEN_ENDED_ALLOWED_EMPTY_ST_COUNT = 1;
export const MATRIX_OPEN_ENDED_DEFAULT_COUNT = 2;

export const MATRIX_OPEN_ENDED_DEFAULT_COUNT_STATEMENTS = 1;
export const MATRIX_OPEN_ENDED_DEFAULT_COUNT_SCALEPOINTS = 3;

export const MATRIX_CONSTANT_SUM_DEFAULT_COUNT_STATEMENTS = 1;
export const MATRIX_CONSTANT_SUM_DEFAULT_COUNT_SCALEPOINTS = 2;
export const MATRIX_CONVERSATIONAL_DEFAULT_COUNT_STATEMENTS = 2;
export const MATRIX_CONVERSATIONAL_DEFAULT_COUNT_SCALEPOINTS = 1;

export const MATRIX_CONVERSATIONAL_CELL_TYPES = {
  GOAL: 2,
  OBJECTIVE: 1,
};

export const MATRIX_OPEN_ENDED_STYLES = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
};

export const MATRIX_OPEN_ENDED_INPUT_SIZE = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
};

export const MATRIX_OPEN_ENDED_SIGN_PLACEMENT = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const ANSWER_COLUMN_VALUE_TYPES = {
  NUMBER: 1,
  NUMER: 1,
};

export const TOGGLE_MANDATORY_MODES = {
  ALL: 'ALL',
  ROW: 'ROW',
  COLUMN: 'COLUMN',
  FIELD: 'FIELD',
};

export const MATRIX_CONSTANT_SUM_TYPES = {
  MUST_TOTAL: 'MUST_TOTAL',
  CONTINUOUS_SUM: 'CONTINUOUS_SUM',
};
